var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, PrimaryColumn, Unique, UpdateDateColumn } from 'typeorm';
import { Project } from './project.js';
import { Test } from './test.js';
let Dependency = class Dependency {
    id;
    createdDate;
    updatedDate;
    origin;
    project;
    projectId;
    test;
    testId;
    snapshotId;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], Dependency.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Dependency.prototype, "createdDate", void 0);
__decorate([
    UpdateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Dependency.prototype, "updatedDate", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Dependency.prototype, "origin", void 0);
__decorate([
    Index(),
    ManyToOne(() => Project, (project) => project.dependencies, { nullable: false, onDelete: 'CASCADE' }),
    JoinColumn({ name: 'projectId' }),
    __metadata("design:type", Project)
], Dependency.prototype, "project", void 0);
__decorate([
    Column('uuid'),
    __metadata("design:type", String)
], Dependency.prototype, "projectId", void 0);
__decorate([
    Index(),
    ManyToOne(() => Test, { nullable: false, onDelete: 'CASCADE' }),
    JoinColumn({ name: 'testId' }),
    __metadata("design:type", Test)
], Dependency.prototype, "test", void 0);
__decorate([
    Column('uuid'),
    __metadata("design:type", String)
], Dependency.prototype, "testId", void 0);
__decorate([
    Index(),
    Column('uuid'),
    __metadata("design:type", String)
], Dependency.prototype, "snapshotId", void 0);
Dependency = __decorate([
    Entity(),
    Unique(['projectId', 'testId', 'origin'])
], Dependency);
export { Dependency };
//# sourceMappingURL=data:application/json;base64,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